(function (root) {
  const SLOTS = ['front', 'rear', 'uca', 'lca', 'bump-front', 'bump-rear', 'links'];

  const SLOT_LABELS = {
    front: 'Front',
    rear: 'Rear',
    uca: 'Upper control arms',
    lca: 'Lower control arms',
    'bump-front': 'Front bump stops',
    'bump-rear': 'Rear bump stops',
    links: 'Links',
  };

  const VEHICLES = [
    { id: 'tacoma', label: 'Tacoma' },
    { id: '4runner', label: '4Runner' },
    { id: 'tundra', label: 'Tundra' },
    { id: 'sequoia', label: 'Sequoia' },
    { id: 'fj', label: 'FJ Cruiser' },
    { id: 'land-cruiser', label: 'Land Cruiser' },
    { id: 'prado', label: 'Prado' },
    { id: 'lexus-gx', label: 'Lexus GX' },
    { id: 'hilux', label: 'Hilux' },
    { id: 'fortuner', label: 'Fortuner' },
    { id: 'pickup', label: 'Toyota Pickup' },
  ];

  const GENERATIONS = {
    tacoma: [
      { id: 'tacoma-4', label: '2024+ / 4th Gen', y0: 2024, y1: 2099 },
      { id: 'tacoma-3', label: '2016-2023 / 3rd Gen', y0: 2016, y1: 2023 },
      { id: 'tacoma-2', label: '2005-2015 / 2nd Gen', y0: 2005, y1: 2015 },
      { id: 'tacoma-1', label: '1995-2004 / 1st Gen', y0: 1995, y1: 2004 },
    ],
    '4runner': [
      { id: '4runner-6', label: '2025+ / 6th Gen', y0: 2025, y1: 2099 },
      { id: '4runner-5', label: '2010-2024 / 5th Gen', y0: 2010, y1: 2024 },
      { id: '4runner-4', label: '2003-2009 / 4th Gen', y0: 2003, y1: 2009 },
      { id: '4runner-3', label: '1996-2002 / 3rd Gen', y0: 1996, y1: 2002 },
    ],
    tundra: [
      { id: 'tundra-3', label: '2022+ / 3rd Gen', y0: 2022, y1: 2099 },
      { id: 'tundra-2', label: '2007-2021 / 2nd Gen', y0: 2007, y1: 2021 },
      { id: 'tundra-1', label: '1999-2006 / 1st Gen', y0: 1999, y1: 2006 },
    ],
    sequoia: [
      { id: 'sequoia-3', label: '2023+ / 3rd Gen', y0: 2023, y1: 2099 },
      { id: 'sequoia-2', label: '2008-2022 / 2nd Gen', y0: 2008, y1: 2022 },
      { id: 'sequoia-1', label: '2001-2007 / 1st Gen', y0: 2001, y1: 2007 },
    ],
    fj: [{ id: 'fj-1', label: '2007-2014 / FJ Cruiser', y0: 2007, y1: 2017 }],
    'land-cruiser': [
      { id: 'lc-300', label: '2022+ / LC300', y0: 2022, y1: 2099 },
      { id: 'lc-250', label: '2024+ / LC250', y0: 2024, y1: 2099 },
      { id: 'lc-200', label: '2008-2021 / LC200', y0: 2008, y1: 2021 },
      { id: 'lc-100', label: '1998-2007 / LC100', y0: 1998, y1: 2007 },
      { id: 'lc-80', label: '1990-1997 / LC80', y0: 1989, y1: 1997 },
      { id: 'lc-70', label: '70-series / 76 78 79', y0: 1984, y1: 2099 },
    ],
    prado: [
      { id: 'prado-150', label: '2009-2023 / Prado 150', y0: 2009, y1: 2023 },
      { id: 'prado-120', label: '2003-2009 / Prado 120', y0: 2003, y1: 2009 },
      { id: 'prado-90', label: '1996-2002 / Prado 90', y0: 1996, y1: 2002 },
    ],
    'lexus-gx': [
      { id: 'gx-550', label: '2024+ / GX550', y0: 2024, y1: 2099 },
      { id: 'gx-460', label: '2010-2023 / GX460', y0: 2010, y1: 2023 },
      { id: 'gx-470', label: '2003-2009 / GX470', y0: 2003, y1: 2009 },
    ],
    hilux: [
      { id: 'hilux-revo', label: '2016+ / Revo', y0: 2016, y1: 2099 },
      { id: 'hilux-vigo', label: '2005-2015 / Vigo', y0: 2005, y1: 2015 },
    ],
    fortuner: [{ id: 'fortuner-1', label: '2011+ / Fortuner', y0: 2011, y1: 2099 }],
    pickup: [{ id: 'pickup-1', label: 'Toyota Pickup', y0: 1984, y1: 1995 }],
  };

  const ALIASES = [
    { re: /4th gen tacoma|tacoma 24\+|tacoma 2024/, v: 'tacoma', g: 'tacoma-4' },
    { re: /3rd gen tacoma/, v: 'tacoma', g: 'tacoma-3' },
    { re: /2nd gen tacoma/, v: 'tacoma', g: 'tacoma-2' },
    { re: /1st gen tacoma/, v: 'tacoma', g: 'tacoma-1' },
    { re: /6th gen 4runner/, v: '4runner', g: '4runner-6' },
    { re: /5th gen 4runner/, v: '4runner', g: '4runner-5' },
    { re: /4th gen 4runner/, v: '4runner', g: '4runner-4' },
    { re: /3rd gen 4runner/, v: '4runner', g: '4runner-3' },
    { re: /3rd gen tundra/, v: 'tundra', g: 'tundra-3' },
    { re: /2nd gen tundra/, v: 'tundra', g: 'tundra-2' },
    { re: /1st gen tundra/, v: 'tundra', g: 'tundra-1' },
    { re: /3rd gen sequoia/, v: 'sequoia', g: 'sequoia-3' },
    { re: /2nd gen sequoia/, v: 'sequoia', g: 'sequoia-2' },
    { re: /1st gen sequoia/, v: 'sequoia', g: 'sequoia-1' },
    { re: /fj cruiser/, v: 'fj', g: 'fj-1' },
    { re: /lexus gx550|\bgx550\b/, v: 'lexus-gx', g: 'gx-550' },
    { re: /lexus gx460|\bgx460\b/, v: 'lexus-gx', g: 'gx-460' },
    { re: /lexus gx470|\bgx470\b/, v: 'lexus-gx', g: 'gx-470' },
    { re: /land cruiser 300|\blc300\b|300 series land cruiser/, v: 'land-cruiser', g: 'lc-300' },
    { re: /land cruiser 250|\blc250\b/, v: 'land-cruiser', g: 'lc-250' },
    { re: /land cruiser 200|\blc200\b/, v: 'land-cruiser', g: 'lc-200' },
    { re: /land cruiser 100|\blc100\b|100 series land/, v: 'land-cruiser', g: 'lc-100' },
    { re: /land cruiser 80|\blc80\b/, v: 'land-cruiser', g: 'lc-80' },
    { re: /76\/78\/79|land cruiser 76/, v: 'land-cruiser', g: 'lc-70' },
    { re: /land cruiser 150/, v: 'prado', g: 'prado-150' },
    { re: /prado 150/, v: 'prado', g: 'prado-150' },
    { re: /prado 120/, v: 'prado', g: 'prado-120' },
    { re: /prado 90/, v: 'prado', g: 'prado-90' },
    { re: /hilux revo/, v: 'hilux', g: 'hilux-revo' },
    { re: /hilux vigo/, v: 'hilux', g: 'hilux-vigo' },
    { re: /fortuner/, v: 'fortuner', g: 'fortuner-1' },
    { re: /toyota pickup/, v: 'pickup', g: 'pickup-1' },
  ];

  const DROP_RE = /\b(titan|montero|pajero|patrol|y62|frontier|colorado|canyon)\b/i;

  function normalize(text) {
    return String(text || '')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/&amp;/g, '&')
      .replace(/landcruiser/gi, 'land cruiser')
      .replace(/4-runner/gi, '4runner')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function blob(product) {
    return `${normalize(product.title)} ${product.handle || ''}`.toLowerCase();
  }

  function addFit(found, vehicle, generation) {
    if (!found.some((item) => item.vehicle === vehicle && item.generation === generation)) {
      found.push({ vehicle, generation });
    }
  }

  function expandYear(value) {
    const n = parseInt(value, 10);
    if (value.length === 2) return n >= 80 ? 1900 + n : 2000 + n;
    return n;
  }

  function vehicleFromModel(model) {
    const m = model.toLowerCase();
    if (/tacoma/.test(m)) return ['tacoma'];
    if (/4runner\/lc120/.test(m)) return ['4runner', 'prado'];
    if (/4runner/.test(m)) return ['4runner'];
    if (/tundra/.test(m)) return ['tundra'];
    if (/sequoia/.test(m)) return ['sequoia'];
    if (/fj/.test(m)) return ['fj'];
    if (/fortuner/.test(m)) return ['fortuner'];
    if (/hilux/.test(m)) return ['hilux'];
    if (/gx550|gx460|gx470|lexus gx/.test(m)) return ['lexus-gx'];
    if (/lx450/.test(m)) return ['land-cruiser'];
    if (/land cruiser 150/.test(m)) return ['prado'];
    if (/land cruiser|lc\d/.test(m)) return ['land-cruiser'];
    if (/prado/.test(m)) return ['prado'];
    if (/pickup/.test(m)) return ['pickup'];
    return [];
  }

  function parseKingPrefix(title) {
    const t = title.toLowerCase();
    let match = t.match(/^(toyota|lexus)\s+(.+?)\s+(\d{4})\s*[-–]\s*(\d{4})/);
    if (match) return { model: match[2], y0: +match[3], y1: +match[4] };
    match = t.match(/^(toyota|lexus)\s+(.+?)\s+(\d{4})\+/);
    if (match) return { model: match[2], y0: +match[3], y1: 2099 };
    match = t.match(/^(toyota|lexus)\s+(.+?)\s+(\d{2})\+/);
    if (match) return { model: match[2], y0: expandYear(match[3]), y1: 2099 };
    return null;
  }

  function parseFitment(title, text) {
    const found = [];
    ALIASES.forEach((alias) => {
      if (alias.re.test(text)) addFit(found, alias.v, alias.g);
    });
    if (/4runner\/lc120/.test(text)) {
      addFit(found, '4runner', '4runner-4');
      addFit(found, 'prado', 'prado-120');
    }

    const prefix = parseKingPrefix(title);
    if (prefix) {
      vehicleFromModel(prefix.model).forEach((vehicle) => {
        const gens = GENERATIONS[vehicle] || [];
        let y0 = prefix.y0;
        let y1 = prefix.y1;
        if (vehicle === '4runner' && /4runner 2010\+/.test(text)) {
          y1 = 2024;
        }
        gens.forEach((gen) => {
          if (gen.y0 <= y1 && y0 <= gen.y1) addFit(found, vehicle, gen.id);
        });
      });
    }

    addScatteredYearFits(found, text);

    return found;
  }

  function addYearFits(found, vehicle, y0, y1) {
    (GENERATIONS[vehicle] || []).forEach((gen) => {
      if (gen.y0 <= y1 && y0 <= gen.y1) addFit(found, vehicle, gen.id);
    });
  }

  function addScatteredYearFits(found, text) {
    const vehicleChunk =
      'tacoma|4runner|tundra|sequoia|fj cruiser|land cruiser(?:\\s*(?:250|300|200|100|80|150))?|lexus gx\\d*|gx\\d+|lx450|prado(?:\\s*\\d+)?|hilux|fortuner|pickup';
    const afterYear = new RegExp(
      `(\\d{2,4})\\s*[-–]\\s*(\\d{2,4}|up|present)\\s+(${vehicleChunk})`,
      'gi'
    );
    let match;
    while ((match = afterYear.exec(text))) {
      const y0 = expandYear(match[1]);
      const y1 = /up|present/i.test(match[2]) ? 2099 : expandYear(match[2]);
      vehicleFromModel(match[3]).forEach((vehicle) => addYearFits(found, vehicle, y0, y1));
    }
    const afterVehicle = new RegExp(
      `(${vehicleChunk})\\s+(\\d{2,4})\\s*[-–]\\s*(\\d{2,4}|up|present)`,
      'gi'
    );
    while ((match = afterVehicle.exec(text))) {
      const y0 = expandYear(match[2]);
      const y1 = /up|present/i.test(match[3]) ? 2099 : expandYear(match[3]);
      vehicleFromModel(match[1]).forEach((vehicle) => addYearFits(found, vehicle, y0, y1));
    }
  }

  function hasFrontAndRear(title) {
    return /front\s*(?:&|and)\s*rear/i.test(title);
  }

  function isBumpKit(title) {
    if (!/bump\s*stops?/i.test(title)) return false;
    if (/\bfox\b/i.test(title)) return false;
    if (/lower control arm/i.test(title)) return false;
    if (/bump stop mounts/i.test(title) && !/kit/i.test(title)) return false;
    return true;
  }

  function bumpSlotInfo(title) {
    if (hasFrontAndRear(title)) {
      return { slot: 'bump-front', fills: ['bump-front', 'bump-rear'], lockUca: false, lockLca: false };
    }
    if (/\brear\b/i.test(title) && !/\bfront\b/i.test(title)) {
      return { slot: 'bump-rear', fills: ['bump-rear'], lockUca: false, lockLca: false };
    }
    if (/\bfront\b/i.test(title) && !/\brear\b/i.test(title)) {
      return { slot: 'bump-front', fills: ['bump-front'], lockUca: false, lockLca: false };
    }
    return { slot: 'bump-rear', fills: ['bump-rear'], lockUca: false, lockLca: false };
  }

  function isLinksWithShocks(title) {
    return /rear links/i.test(title) && /king|bypass/i.test(title);
  }

  function slotFor(title, type, isKing) {
    if (isBumpKit(title)) {
      return bumpSlotInfo(title);
    }
    if (/sway\s*bar\s*link/i.test(title)) {
      return { slot: 'links', fills: ['links'], lockUca: false, lockLca: false };
    }
    if (/rear links/i.test(title)) {
      return {
        slot: 'links',
        fills: isLinksWithShocks(title) ? ['links', 'rear'] : ['links'],
        lockUca: false,
        lockLca: false,
      };
    }

    if (isKing) {
      if (/\bfront\b/i.test(title) && !hasFrontAndRear(title)) {
        return { slot: 'front', fills: ['front'], lockUca: false, lockLca: false };
      }
      if (/\brear\b/i.test(title)) {
        return { slot: 'rear', fills: ['rear'], lockUca: false, lockLca: false };
      }
      return null;
    }

    if (type === 'Upper Control Arms') {
      return { slot: 'uca', fills: ['uca'], lockUca: false, lockLca: false };
    }
    if (type === 'Lower Control Arms') {
      return { slot: 'lca', fills: ['lca'], lockUca: false, lockLca: false };
    }
    if (type === 'Mid Travel Packages' || (type === 'Front Packages' && /mid[- ]travel/i.test(title))) {
      return { slot: 'front', fills: ['front', 'rear'], lockUca: true, lockLca: true };
    }
    if (type === 'Front Packages') {
      return {
        slot: 'front',
        fills: hasFrontAndRear(title) ? ['front', 'rear'] : ['front'],
        lockUca: true,
        lockLca: false,
      };
    }
    return null;
  }

  function cardLabel(title, slotInfo) {
    const bits = [];
    if (/lift kit/i.test(title)) {
      bits.push(hasFrontAndRear(title) ? 'Front & rear kit' : 'Front kit');
    } else if (/^uca w\//i.test(title)) {
      bits.push(hasFrontAndRear(title) ? 'UCA + front & rear' : 'UCA + coilovers');
    }
    if (/mid[- ]travel/i.test(title)) bits.push('Mid-travel');
    if (/overtrail/i.test(title)) bits.push('Overtrail');
    else if (/\bkdss\b/i.test(title)) bits.push('KDSS');
    if (/3(?:\.0|0)/.test(title) && /inch|dia/i.test(title)) bits.push('3.0');
    else if (/2(?:\.5|5)/.test(title) && /inch|dia/i.test(title)) bits.push('2.5');
    if (/\bibp\b|internal bypass/i.test(title)) bits.push('IBP');
    if (/stage\s*3/i.test(title)) bits.push('Stage 3');
    if (slotInfo.slot === 'front' || slotInfo.slot === 'rear') {
      if (/w\/?\s*adjuster|with adjuster/i.test(title)) bits.push('With adjuster');
      else if (/coil|shock|reservoir/i.test(title) && !/lift kit|uca w\//i.test(title)) {
        bits.push('Regular');
      }
    }
    if (slotInfo.slot === 'uca' && /heim/i.test(title)) bits.push('Heim');
    if (slotInfo.slot === 'lca') {
      if (/dual shock/i.test(title)) bits.push('Dual shock');
      if (/single shock/i.test(title)) bits.push('Single shock');
    }
    if (slotInfo.slot === 'bump-front' || slotInfo.slot === 'bump-rear') {
      const extended = title.match(/(\d+(?:\.\d+)?)\s*-?\s*inch extended/i);
      if (extended) bits.push(`${extended[1]} inch extended`);
    }
    return bits.join(' · ');
  }

  function classifyProduct(raw) {
    if (!raw) return null;
    const title = normalize(raw.title);
    const text = blob(raw);
    if (DROP_RE.test(text)) return null;

    const vendor = raw.vendor || '';
    const type = raw.product_type || '';
    const isKing = /king shocks/i.test(vendor);
    const isTc = /total chaos/i.test(vendor);
    const isDuro = /durobumps|duro bumps/i.test(vendor);
    if (!isKing && !isTc && !isDuro) return null;
    if (isKing && /steering stabilizer/i.test(title)) return null;
    if (isTc && (type === 'Long Travel' || type === 'Replacement Parts')) return null;
    if (isTc && type === 'Front Accessories' && !isBumpKit(title)) return null;
    if (isDuro && (type !== 'Bump Stops' || /no-thuds/i.test(title))) return null;

    const fitment = parseFitment(title, text);
    if (!fitment.length) return null;

    const slotInfo = slotFor(title, type, isKing);
    if (!slotInfo) return null;

    const variant = (raw.variants && raw.variants[0]) || {};
    const image =
      (raw.images && raw.images[0] && raw.images[0].src) ||
      (raw.featured_image && raw.featured_image.src) ||
      null;

    return {
      id: raw.id,
      variantId: variant.id,
      handle: raw.handle,
      title,
      url: `/products/${raw.handle}`,
      vendor: isKing ? 'King' : isDuro ? 'DuroBumps' : 'Total Chaos',
      price: variant.price,
      available: Boolean(variant.available),
      image,
      slot: slotInfo.slot,
      fills: slotInfo.fills.slice(),
      lockUca: slotInfo.lockUca,
      lockLca: slotInfo.lockLca,
      fitment,
      label: cardLabel(title, slotInfo),
    };
  }

  function classifyCatalog(products) {
    return (products || []).map(classifyProduct).filter(Boolean);
  }

  function emptySlots() {
    return {
      front: null,
      rear: null,
      uca: null,
      lca: null,
      'bump-front': null,
      'bump-rear': null,
      links: null,
    };
  }

  function resetWizardState() {
    return {
      vehicle: null,
      generation: null,
      slots: emptySlots(),
    };
  }

  function occupyingSlots(slots, product) {
    return SLOTS.filter((slot) => slots[slot] && slots[slot].variantId === product.variantId);
  }

  function isAvailable(slots, product) {
    return product.fills.every((slot) => {
      const current = slots[slot];
      return !current || current.variantId === product.variantId;
    });
  }

  function selectProduct(slots, product) {
    const next = Object.assign({}, slots);
    const occupying = occupyingSlots(next, product);
    if (occupying.length) {
      occupying.forEach((slot) => {
        next[slot] = null;
      });
      if (product.lockUca && next.uca && next.uca.variantId === product.variantId) {
        next.uca = null;
      }
      if (product.lockLca && next.lca && next.lca.variantId === product.variantId) {
        next.lca = null;
      }
      return next;
    }
    if (!isAvailable(next, product)) return slots;
    product.fills.forEach((slot) => {
      next[slot] = {
        variantId: product.variantId,
        included: slot !== product.slot,
        product,
      };
    });
    if (product.lockUca) {
      next.uca = { variantId: product.variantId, included: true, product };
    }
    if (product.lockLca) {
      next.lca = { variantId: product.variantId, included: true, product };
    }
    return next;
  }

  function optionsForSlot(products, vehicle, generation, slot, slots) {
    return (products || []).filter((product) => {
      if (product.slot !== slot) return false;
      if (!product.fitment.some((item) => item.vehicle === vehicle && item.generation === generation)) {
        return false;
      }
      if (slots && !isAvailable(slots, product) && !occupyingSlots(slots, product).length) {
        return false;
      }
      return true;
    });
  }

  function vehiclesIn(products) {
    const present = new Set();
    products.forEach((product) => {
      product.fitment.forEach((item) => present.add(item.vehicle));
    });
    return VEHICLES.filter((vehicle) => present.has(vehicle.id));
  }

  function generationsIn(products, vehicle) {
    const present = new Set();
    products.forEach((product) => {
      product.fitment.forEach((item) => {
        if (item.vehicle === vehicle) present.add(item.generation);
      });
    });
    return (GENERATIONS[vehicle] || []).filter((gen) => present.has(gen.id));
  }

  function generationLabel(vehicle, generation) {
    const row = (GENERATIONS[vehicle] || []).find((gen) => gen.id === generation);
    return row ? row.label : generation;
  }

  const api = {
    SLOTS,
    SLOT_LABELS,
    VEHICLES,
    GENERATIONS,
    parseFitment,
    classifyProduct,
    classifyCatalog,
    emptySlots,
    resetWizardState,
    selectProduct,
    isAvailable,
    optionsForSlot,
    vehiclesIn,
    generationsIn,
    generationLabel,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.P4SpecCatalog = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
